import api from 'services/financial/receivable'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
